module.exports = __webpack_public_path__ + "img/ring_y_o_null_0@3x.dfb39f6a.png";